"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCachedFragment = getCachedFragment;
exports.cacheFragment = cacheFragment;
exports.evictLocalOverrides = evictLocalOverrides;
exports.evictObjectFromCache = evictObjectFromCache;
exports.clearCacheOnRouteChange = clearCacheOnRouteChange;
exports.handleClearCacheOnRouteChange = handleClearCacheOnRouteChange;
const log_1 = require("@aurora/shared-utils/log");
const exenv_1 = require("exenv");
const log = (0, log_1.getLog)(module);
const routeCacheId = 'aurora.routeCache';
/**
 * A helper to deal with reading and writing cache fragments to and from the apollo cache.
 */
function getTypeFromFragment(fragment) {
    return fragment.definitions[0].typeCondition.name.value;
}
/**
 * Read a cached fragment from the apollo client cache.
 * @param client the apollo client
 * @param fragment the fragment to read
 * @param id the id of the object in cache
 */
function getCachedFragment(client, fragment, id) {
    if (!id) {
        return null;
    }
    const now = performance.now();
    const type = getTypeFromFragment(fragment);
    const fragmentId = `${type}:${id}`;
    const fragmentData = client.readFragment({
        id: fragmentId,
        fragment
    });
    if (fragmentData) {
        log.trace('Found %s in apollo cache in %dms', fragmentId, performance.now() - now);
        return fragmentData;
    }
    return null;
}
/**
 * Write a cached fragment to the apollo client cache.
 * @param client the apollo client
 * @param fragment the fragment to write
 * @param id the id of the object in cache
 * @param fragmentData the data to write to the fragment
 */
function cacheFragment(client, fragment, id, fragmentData) {
    const type = getTypeFromFragment(fragment);
    const fragmentId = `${type}:${id}`;
    if (fragmentData) {
        const queryNow = performance.now();
        log.trace('caching %s to apollo cache', fragmentId);
        try {
            client.writeFragment({
                id: fragmentId,
                fragment,
                data: Object.assign(Object.assign({}, fragmentData), { id, __typename: type })
            });
            log.trace('cached %s to apollo cache in %dms', fragmentId, performance.now() - queryNow);
        }
        catch (error) {
            log.error(error, 'error caching fragment %s to apollo cache with data: %O', fragmentId, fragmentData);
        }
    }
    else {
        log.warn('attempting to cache empty fragment %s to apollo cache', fragmentId);
    }
}
/**
 * Evict any local overrides from the cache
 * @param client
 * @param cachedAsset
 */
function evictLocalOverrides(client, cachedAsset) {
    if ((cachedAsset === null || cachedAsset === void 0 ? void 0 : cachedAsset.localOverride) === true) {
        client.cache.evict({ id: client.cache.identify(cachedAsset) });
    }
}
/**
 * Updates cache evicting the object.
 *
 * @param cache Apollo cache instance
 * @param object the object to evict from cache
 * @param broadcast whether to broadcast the cache change (forces refetch).
 */
function evictObjectFromCache(cache, object, broadcast = false) {
    const id = cache.identify(object);
    return cache.evict({ id, broadcast });
}
/**
 * Handle resetting the cache on route change.
 *
 * @param url the url
 * @param client the apollo client
 */
function handleClearCacheOnRouteChange(url, client) {
    if (exenv_1.canUseDOM) {
        const pageCache = localStorage.getItem(routeCacheId);
        if (pageCache && pageCache !== url) {
            localStorage.removeItem(routeCacheId);
            client.clearStore();
            client.cache.gc();
        }
    }
}
/**
 * Set the page cache ID to the current page, this is used to clear the cache on route change.
 */
function clearCacheOnRouteChange() {
    if (exenv_1.canUseDOM) {
        localStorage.setItem(routeCacheId, window.location.pathname);
    }
}
//# sourceMappingURL=apolloCacheHelper.js.map